import { hasFlexibleDates, hasExactDates } from '~/util/weddingDates';

import { WeddingDateFormFields } from '../WeddingDateField/types';
import { buildFlexibleDatesRequest } from './buildFlexibleDatesRequest';

export const isExpandedDateAnswered = (values: WeddingDateFormFields): boolean => {
  const weddingDates = buildFlexibleDatesRequest(values);
  return hasFlexibleDates(weddingDates) || hasExactDates(weddingDates, 1);
};
